import { getUtcDateWithDayAndTime } from "utils/helpers/getUtcDateWithDayAndTime"
import { format as formatDate } from "utils/datetime-format-utils"

export function getFormatDateWithDayAndTime({
    day,
    time,
    format = "d MMMM, EEEE, H:mm",
}: {
    day: string | null
    time: string | null
    format?: string
}): string | null {
    const getDate = day && time ? getUtcDateWithDayAndTime(day, time) : null
    return getDate ? formatDate(getDate, format) : null
}
